import React, {useEffect, useRef, useState,} from 'react';
import ReactDOM from 'react-dom';
import Waiting from '../Chapas_Norte_Elementor_Widget_Component/loading';
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.css'
import {AiFillCheckCircle} from 'react-icons/ai';
import {GoAlert} from 'react-icons/go';

export default function Chapas_Norte_Cantos_Validator_Elementor_Widget() {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') || '';
    const [searchTerm, setSearchTerm] = useState(id);
    const [loading, setLoading] = useState(true);
    const formRef = useRef(null);
    const apiUrl = '/wp-json';
    const urlget = `${apiUrl}/chapas-norte/cantos/validator/get`;
    const urlsave = `${apiUrl}/chapas-norte/cantos/validator/save`;

    //setings
    const element = document.getElementById('chapas_norte_cantos_validator_elementor_widget');
    const inputplaceholder = element.dataset.inputPlaceholder;
    const titletextext = element.dataset.textValue;
    const innertext = element.dataset.innerContent;
    const success = element.dataset.successContent;
    const alert = element.dataset.alertContent;
    const handleChange = (event) => {
        setSearchTerm(event.target.value)
    };

    const handleRButtonChange = (e) => {
        if (e.target.value === 'D') {
            const elemento = document.getElementById("textadisconf");
            elemento.style.display = ""
        } else {
            const elemento = document.getElementById("textadisconf");
            elemento.style.display = "none"
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(false);
        ReactDOM.render(<div></div>, document.getElementById('insidezone'));
        axios
            .get(urlget, {
                params: {
                    id: searchTerm
                }
            })
            .then((res) => {
                const data = res.data;
                setLoading(true);
                ReactDOM.render(<Validator data={data}/>, document.getElementById('insidezone'));
            })
            .catch((err) => {
                setLoading(true);
            });
    };

    useEffect(() => {
        if (id && formRef.current) {
            setSearchTerm(id);
            axios
                .get(urlget, {
                    params: {
                        id: id
                    }
                })
                .then((res) => {
                    const data = res.data;
                    setLoading(true);
                    ReactDOM.render(<Validator data={data}/>, document.getElementById('insidezone'));
                })
                .catch((err) => {
                    setLoading(true);
                });
        }
    }, [id]);

    function Alerts(props) {
        const tipo = props.data;

        const tipeOfAlert = () => {
            if (tipo == '1') {
                return (
                    <div className="alert alert-success d-flex align-items-center  elementor-list-widget-alert-success"
                         role="alert">
                        <AiFillCheckCircle/>
                        <div
                            className="ms-2 elementor-list-widget-text-success elementor-list-widget-alert-success-text">
                            {success}
                        </div>
                    </div>
                );
            } else if (tipo == '2') {
                return (
                    <div className="alert alert-danger d-flex align-items-center elementor-list-widget-alert-error"
                         role="alert">
                        <GoAlert/>
                        <div className="ms-2 elementor-list-widget-text-alert elementor-list-widget-alert-error-text">
                            {alert}
                        </div>
                    </div>
                );
            }
        }

        return (
            <div>
                {tipeOfAlert()}
            </div>
        )
    }

    function Validator(props) {
        const estado = props.data.estado;

        //peticion para validar formulario de validacion
        const handleSubmitValidation = (event) => {
            event.preventDefault();

            document.getElementById("loadingproces").style.display = ""
            //obtener estado de radiobutton
            let estado;
            if (document.getElementById("flexRadioDefault1").checked) {
                estado = document.getElementById("flexRadioDefault1").value;
            } else if (document.getElementById("flexRadioDefault2").checked) {
                estado = document.getElementById("flexRadioDefault2").value;
            }

            //obtener disconformidad del text area
            const disconformidad = document.getElementById("textareaDisconforme").value;

            //desactivar opciones
            document.getElementById("flexRadioDefault1").setAttribute('disabled', 'disabled');
            document.getElementById("flexRadioDefault2").setAttribute('disabled', 'disabled');
            document.getElementById("textareaDisconforme").setAttribute('disabled', 'disabled');

            //peticion axios
            axios
                .post(urlsave, {
                    id: searchTerm,
                    estado: estado,
                    disconformidad
                })
                .then((res) => {
                    const data = res.data;
                    document.getElementById("loadingproces").style.display = "none";
                    ReactDOM.render(<Alerts data={'1'}/>, document.getElementById('processzone'));
                })
                .catch((err) => {
                    document.getElementById("loadingproces").style.display = "none";
                    ReactDOM.render(<Alerts data={'2'}/>, document.getElementById('processzone'));
                });
        }

        // creacion del html
        const htmlContent = () => {
            if (estado == 'N') {
                return (
                    <h3 className="h2 fontspace-835669 font-weight-400 text-color-199395-color">
                        <span>The request does not exist</span>
                    </h3>
                );
            }
            if (estado == 'V') {
                return (
                    <h3 className="h2 fontspace-835669 font-weight-400 text-color-199395-color">
                        <span>The order has already been validated</span>
                    </h3>
                );
            }
            if (estado == 'D') {
                return (
                    <h3 className="h2 fontspace-835669 font-weight-400 text-color-199395-color">
                        <span>The order has already been modified with the indicated disagreement</span>
                    </h3>
                )
            }
            if (estado == 'A') {
                return (<h3 className="h2 fontspace-835669 font-weight-400 text-color-199395-color">
                    <span>The request has already been processed</span>
                </h3>)
            }
            if (estado == 'P') {
                return (
                    <div className="uncode_text_column">
                        <div className="uncode_text_column">
                            <p className={"elementor-list-widget-inner-text"}>
                                <b>{props.data.rsocial}</b><br/>
                                <b>Reference: </b>{props.data.referencia}<br/>
                                <b>Order number: </b>{searchTerm}
                            </p>
                        </div>
                        <h3 className="h2 fontspace-835669 font-weight-400 text-color-199395-color elementor-list-widget-inner-title">
                            {innertext}
                        </h3>
                        <form id="formValidar">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault"
                                       id="flexRadioDefault1" onClick={handleRButtonChange} value={'V'}/>
                                <label className="form-check-label " htmlFor="flexRadioDefault1">
                                    Validate order
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input " type="radio" name="flexRadioDefault"
                                       id="flexRadioDefault2" onClick={handleRButtonChange} value={'D'}/>
                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                    Dissatisfied Order
                                </label>
                            </div>
                            <div className="input-group" id="textadisconf" style={{display: "none"}}>
                                    <textarea
                                        className="form-control"
                                        aria-label="With textarea"
                                        id={"textareaDisconforme"}
                                    ></textarea>
                            </div>
                            <p className={"mt-3"} id="processzone">
                                <button type="submit" onClick={handleSubmitValidation}
                                        className={"elementor-list-widget-button btn btn-primary"}>
                                    <Waiting id="loadingproces" hidden={true}/>
                                    Process
                                </button>
                            </p>
                        </form>
                    </div>
                );
            }
        };

        //mostrar el html
        return (
            <div className="row d-flex justify-content-center">
                {htmlContent()}
            </div>
        );
    }

    return (
        <div>
            <form ref={formRef} onSubmit={handleSubmit}>
                <p className="elementor-list-widget-text elementor-list-widget-text-pa">{titletextext}</p>
                <div className={"input-group "}>
                    <input
                        className=" elementor-list-widget-text-place form-control"
                        type="text"
                        value={searchTerm}
                        onChange={handleChange}
                        disabled={!loading}
                        placeholder={inputplaceholder}
                    />

                    <button
                        type="submit"
                        onClick={handleSubmit}
                        className={"elementor-list-widget-button btn btn-primary"}
                        disabled={!loading}
                    >
                        <Waiting id="x" hidden={loading}/>
                        Search
                    </button>
                </div>
            </form>

            <div className="mt-3" id={"insidezone"}></div>
        </div>
    );
}